import LoadZuora from './loadZuora';

class Zuora {
  static initialize(options = 'stage') {
    LoadZuora(options);
  }
}

export default Zuora;
